import type { Catalog } from '..'

export const onboarding: Catalog['onboarding'] = {
  stepOf: '{step} / {total}',
  continueButton: 'Continuar',
  backButton: 'Voltar',
  skipButton: 'Pular',
  finishButton: 'Abrir meu canvas',
  hint: 'Leva 20 segundos. Você pode mudar isso depois em Configurações.',
  saveFailed: 'Não foi possível salvar suas respostas — tente de novo',

  roleTitle: 'O que melhor descreve você?',
  roleLede: 'Isso nos ajuda a construir o Doop para quem o usa. Escolha o mais próximo.',
  roleDesigner: 'Designer',
  roleDesignerBlurb: 'Produto, UX ou visual. Você pensa em frames.',
  roleEngineer: 'Engenheiro(a)',
  roleEngineerBlurb: 'Você entrega o código. Um design é uma especificação.',
  roleVibeCoder: 'Vibe coder',
  roleVibeCoderBlurb: 'Você constrói com IA e aprende no caminho.',
  roleFounder: 'Fundador(a) ou PM',
  roleFounderBlurb: 'Você decide o que é construído, não os pixels.',
  roleMarketer: 'Marketing',
  roleMarketerBlurb: 'Landing pages, campanhas, criativos em volume.',
  roleExploring: 'Só explorando',
  roleExploringBlurb: 'Curioso(a), sem projeto ainda. Tudo bem.',

  intentTitle: 'O que você veio fazer primeiro?',
  intentLede: 'Escolha o mais próximo. Isso nos diz no que o Doop precisa ficar melhor.',
  intentLanding: 'Uma landing page',
  intentLandingBlurb: 'Site de marketing, página de lançamento, preços.',
  intentProductUi: 'Interface de produto',
  intentProductUiBlurb: 'Telas de app, dashboards, configurações, fluxos.',
  intentPrototype: 'Um protótipo clicável',
  intentPrototypeBlurb: 'Telas conectadas para testar uma ideia.',
  intentSocial: 'Criativos para redes e anúncios',
  intentSocialBlurb: 'Posts, banners, imagens de destaque, vários tamanhos.',
  intentEmail: 'Um e-mail',
  intentEmailBlurb: 'Newsletter, ciclo de vida ou lançamento.',
  intentUnsure: 'Ainda não sei',
  intentUnsureBlurb: 'Me mostre o lugar primeiro.',

  aboutTitle: 'Sobre você',
  aboutDescription: 'As perguntas de boas-vindas: quem você é e o que veio fazer.',
  aboutRow: 'Suas respostas',
  aboutUnanswered: 'Ainda sem resposta',
  aboutUpdate: 'Atualizar respostas',
  aboutSaved: 'Salvo',
}
